import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionPageComponent } from '@pages/layout/subscription/subscription-page/subscription-page.component';
import { AddSubscriptionPageComponent } from '@pages/layout/subscription/add-subscription-page/add-subscription-page.component';
import { EditSubscriptionPageComponent } from '@pages/layout/subscription/edit-subscription-page/edit-subscription-page.component';
import { ScenarioAddComponent } from '@pages/layout/subscription/scenario/scenario-add/scenario-add.component';
import { ScenarioEditComponent } from '@pages/layout/subscription/scenario/scenario-edit/scenario-edit.component';
import { ScenarioPageComponent } from '@pages/layout/subscription/scenario/scenario-page/scenario-page.component';

const routes: Routes = [
  {
    path: '', component: SubscriptionPageComponent
  },

  {
    path: 'add', component: AddSubscriptionPageComponent
  },
  {
    path: 'edit/:subId', component: EditSubscriptionPageComponent
  },
  {
    path: 'scenario', component: ScenarioPageComponent
  },
  {
    path: 'scenario/add', component: ScenarioAddComponent
  },
  {
    path: 'scenario/edit/:scenarioId', component: ScenarioEditComponent
  },


];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class SubscriptionRoutingModule { }
